// extracted by mini-css-extract-plugin
export default {"container":"_2EgyQvZhZ4pMQhHQbFn9n_"};